import { NavLink, Outlet } from 'react-router-dom';
import { AdSlot } from '@/components/AdSlot';
import { CmpBootstrap } from '@/components/CmpBootstrap';
import { brand } from '@/config/brand';
import { useCatalog } from '@/hooks/CatalogContext';

const nav = [
  { to: '/', label: 'Catalog', end: true },
  { to: '/beer/', label: 'Beer' },
  { to: '/liquor/', label: 'Liquor' },
  { to: '/wine/', label: 'Wine' },
  { to: '/mixed-drinks/', label: 'Mixed' },
  { to: '/seltzers/', label: 'Seltzers' },
  { to: '/cider/', label: 'Cider' },
  { to: '/compare/', label: 'Compare' },
  { to: '/guides/', label: 'Guides' },
  { to: '/methodology/', label: 'Methodology' },
  { to: '/feedback/', label: 'Feedback' },
];

export function Layout() {
  const { announcement } = useCatalog();
  return (
    <>
      <CmpBootstrap />
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <div className="live-region" aria-live="polite">
        {announcement}
      </div>
      <header className="site-header">
        <div className="site-header__inner">
          <NavLink to="/" className="brand-link" end>
            Booze<span>Ratio</span>
          </NavLink>
          <nav className="nav-links" aria-label="Primary">
            {nav.map((item) => (
              <NavLink key={item.to} to={item.to} end={item.end}>
                {({ isActive }) => (
                  <span aria-current={isActive ? 'page' : undefined}>
                    {item.label}
                  </span>
                )}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main id="main" className="site-main">
        <AdSlot slot="pageTop" label="Advertisement" />
        <Outlet />
        <AdSlot slot="pageBottom" label="Advertisement" />
      </main>
      <footer className="site-footer">
        <nav aria-label="Footer">
          <NavLink to="/about/">About</NavLink>
          <NavLink to="/guides/">Guides</NavLink>
          <NavLink to="/changelog/">What’s new</NavLink>
          <NavLink to="/feedback/">Feedback</NavLink>
          <NavLink to="/privacy/">Privacy</NavLink>
          <NavLink to="/terms/">Terms</NavLink>
          <NavLink to="/methodology/">Methodology</NavLink>
        </nav>
        <p>
          {brand.name}: {brand.tagline} {brand.positioning} {brand.adultNotice}
        </p>
      </footer>
    </>
  );
}
